import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent, IconsModule, SelectOption } from '@troyai/ui-kit';

@Component({
  selector: 't-phone-dialer-trigger',
  imports: [IconsModule, ButtonComponent],
  templateUrl: './phone-dialer-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneDialerTriggerComponent {
  @Input() callingDisabled = false;
  @Input() callPurposeOptions: SelectOption<string>[] = [];
  @Input() suggestedCallPurpose = '';
  @Input({ required: true }) phoneNumber!: string;
  @Input() hasOngoingCall = false;
  @Output() triggerCall = new EventEmitter<{ phoneNumber: string }>();

  dialPhoneNumber() {
    this.triggerCall.emit({
      phoneNumber: this.phoneNumber,
    });
  }
}
